let initialState = {
  data: {},
  listSelected: []
}

function xuLyTrung(state = initialState, action) {
  let newState = {
    ...state
  };
  switch (action.type) {
    case 'UPDATE_XULYTRUNG':
      newState.data = action.data;
      return newState;
    case 'RESETDATA_XULYTRUNG':
      newState.data = [];
      return newState;
    case 'ADD_DANH_SACH_TTT_SELECTED':
      newState.listSelected = action.data;
      localStorage.setItem('listSelectThanhTraTrung', JSON.stringify(action.data));
      return newState;
    case 'RESET_LIST_SELECT_TTT':
      newState.listSelected = [];
      localStorage.removeItem('listSelectThanhTraTrung');
      return newState;
    default:
      return newState;
  }
}

export { xuLyTrung }



// WEBPACK FOOTER //
// ./src/reducers/xuLyTrung.js